import { render, staticRenderFns } from "./servico-select.vue?vue&type=template&id=7169771a&scoped=true&"
import script from "./servico-select.vue?vue&type=script&lang=js&"
export * from "./servico-select.vue?vue&type=script&lang=js&"
import style0 from "./servico-select.vue?vue&type=style&index=0&id=7169771a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7169771a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VSelect})
